import { useMutation } from '@tanstack/react-query';
import { useDict } from '../../i18n/dictionary';
import { api, unwrap } from '../../lib/api';
import {
  useCreateResource,
  useDeleteResource,
  useResourceQuery,
  useUpdateResource,
} from '../../lib/crud';
import { brainDict } from './i18n';

const NOTES = ['brain', 'notes'] as const;

export function useNotes() {
  const t = useDict(brainDict);
  return useResourceQuery(NOTES, api.brain.listNotes, t.loadNotesFailed);
}

export function useCreateNote() {
  const t = useDict(brainDict);
  return useCreateResource(NOTES, api.brain.createNote, t.createNoteFailed);
}

export function useUpdateNote() {
  const t = useDict(brainDict);
  return useUpdateResource(
    NOTES,
    api.brain.updateNote,
    t.updateNoteFailed,
    t.noteSaved,
  );
}

export function useDeleteNote() {
  const t = useDict(brainDict);
  return useDeleteResource(NOTES, api.brain.deleteNote, t.deleteNoteFailed);
}

/**
 * Asking is the one call here that is not a `lib/crud` shape and not
 * `useInvalidating`: it reads, writes nothing, and so has no query key to
 * invalidate. Caching it would be wrong too — the same question asked again
 * after saving a note should be answered again.
 */
export function useAsk() {
  const t = useDict(brainDict);
  return useMutation({
    mutationFn: async (question: string) =>
      unwrap(await api.brain.ask({ body: { question } }), 200, t.askFailed),
  });
}
